export default __webpack_public_path__ + "static/media/loading.2f0d390d.svg";